var React = require('react');

function Wand (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128 272v36.87L186.6 256H144a16 16 0 0 0-16 16zm248.35-80H400a16 16 0 0 0 16-16v-28z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M507.87 46.18L97.16 501.44A32 32 0 0 1 52 503.71q-.6-.54-1.17-1.11L9.37 461.17a32 32 0 0 1 0-45.25c.38-.38.77-.75 1.16-1.11L465.79 4.11a16 16 0 0 1 22 .55l19.48 19.47a16 16 0 0 1 .6 22.05z","className":"fa-primary","key":2})]);
}

Wand.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Wand;

Wand.default = Wand;
